import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild, ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import {MatTableDataSource, MatTableDataSourcePaginator} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {FuncionesExterno} from "../externo/funciones-Externo";
import {HttpClient} from "@angular/common/http";
import {Peticiones} from "./services/Peticiones";
import {DetallePeticionComponent} from "./detalle_peticion/detalle_peticion.component";
import {PetTall} from "../../Models/PetTall";
import {MatDialog} from "@angular/material/dialog";
import {ReclamacionesOverlay} from "./reclamacion_overlay/reclamacion_overlay.component";
import {Gestiones} from "./services/Gestiones";
import {Router} from "@angular/router";
import {AlertArgumentarioComponent} from "../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import { ChangeDetectorRef } from '@angular/core';
import {DetalleDevolucionComponent} from "./detalle_devolucion/detalle_devolucion.component";

export interface PeticioElement {
    peticion: number;
    estado: string;
    estimacion_entrega: string;
    gestion: number;
    gestion_final: string;
    cdn: string;
}

export interface DevolucioElement {
    devolucio: number;
    estado: string;
    matricula: string;
    pdf: string;
}

@Component({
    selector: 'ral-peticiones',
    templateUrl: './peticiones.component.html',
    styleUrls: ['./peticiones.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({height: '0px', minHeight: '0'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})

export class PeticionesComponent implements OnInit, OnDestroy, AfterViewInit
{
    static username: string = '';
    token: string = '';
    urlIconUser: string = '../../assets/icons/icon_user.svg';
    urlIconClose: string = '../../assets/icons/icon_cerrar_sesion.svg';
    buttonText: string = '';
    buttonIcon: string = '';

    /*
    * Selector de taller para supervisor
    */

    public talleresSeleccionables: string[][] = [
      ["", "Todos"],
      ["6001", "Aurgi Goya"],
      ["6002", "Motortown Getafe"]
    ];

    public tallerActual: string = "";

    public usuariosSupervisor: string[] = [
      "aurgi_cc_01"
    ];

    /*
    * Inicialización parametros tabla y busqueda gestión petición
    * */


    peticionesEncontradas:PeticioElement[] = [];

    displayedColumns: string[] = ['arrow','matricula', 'peticion', 'pet_aurgi', 'tipo_pedido', 'estado', 'estimacion_entrega','max_fecha_entrega','gestion'];
    //displayedColumnsDetalle: string[] = ['peticion','matricula', 'marca', 'modelo','estado', 'f_entrega', 'eurocode', 'oem', 'ref_ral', 'gestion'];
    displayedColumnsDetalle: string[] = ['peticion','matricula', 'marca','modelo','estado', 'f_entrega', 'eurocode', 'oem', 'ref_ral', 'gestion'];
    nombrePersonalizadoDetalle: string[] = ['', 'Matrícula', 'Marca', 'Modelo', 'Estado', 'F.Entrega', 'Eurocode', 'OEM', 'Ref.Ral', 'Gestión'];
    arrayCategoria: string[] = ["PARABRISAS","DESCENDENTE DELANTERO IZQUIERDA","DESCENDENTE DELANTERO DERECHO","COSTADO DELANTERO IZQUIERDO","COSTADO DELANTERO DERECHO","FIJO DELANTERO IZQUIERDO","FIJO DELANTERO DERECHO","COSTADO CENTRAL IZQUIERDO","COSTADO CENTRAL DERECHO","COSTADO CENTRAL DERECHO","COSTADO CENTRAL IZQUIERDO","DESCENDENTE TRASERO IZQUIERDO","DESCENDENTE TRASERO DERECHO","COSTADO TRASERO IZQUIERDO","COSTADO TRASERO DERECHO","FIJO TRASERO IZQUIERDO","FIJO TRASERO DERECHO", "LUNETA", "LUNETA IZQUIERDA","LUNETA DERECHA","SEPARACION DE CARGA","TECHO SOLAR", "OTRO"]
    estados = [
      { value: 'O', label: 'Chequeando', img: '../../assets/icons/speed/icon_pendiente.svg'},
      { value: '1', label: 'Procesando', img: '../../assets/icons/speed/icon_preparado.svg'},
      { value: '2', label: 'Empaquetado', img: '../../assets/icons/speed/icon_servido.svg'},
      { value: 'A', label: 'Enviado', img: '../../assets/icons/speed/icon_tramitado.svg'},
      { value: 'S', label: 'Recepcionado', img: '../../assets/icons/speed/icon_reservado.svg'},
      { value: 'An', label: 'Anulado', img: '../../assets/icons/speed/icon_anulado.svg'}
    ];


    dataSource: MatTableDataSource<PeticioElement> = new MatTableDataSource(this.peticionesEncontradas);
    detailData: { [key: string]: any } = {};

    minDate: Date = new Date(2024, 9, 25);
    fechaInicio:Date = new Date();
    fechaFin:Date = new Date();
    fechaPrevInicio  : Date | undefined;
    fechaPrevFin:Date | undefined;
    matriculaPet : string = "";
    peticionPet : string = "";
    selectedCat: string = '';
    selectedEstado: string = '';
    eurocode: string = "";

    traduccionEstadoFinal: { [key: string] : string;  } = {
        "E": "Reclamado",
        "D": "Devuelto",
        "R": "Recepcionado",
        "C": "Cancelado",
    }

    traduccionGestion: { [key: string] : string[][];  } = {
        "": [['Cancelar', 'cancel-btn']],
        "P": [['Recepcionar', 'receive-btn'],['Reclamar', 'reclaim-btn']],
        "S": [['Devolver', 'return-btn']],
        "R": [['Cancelar', 'cancel-btn']],
        "F": [['Devolver', 'return-btn'],['Reclamar', 'reclaim-btn']],
        "T": [['Cancelar', 'cancel-btn']],
        "B": [['Cancelar', 'cancel-btn']],
        "O": [['Cancelar', 'cancel-btn']]

    }

    traduccionEstado: { [key: string] : string;  } = {
        "": "Pendiente",
        "A": "Anulado",
        "P": "Preparado",
        "S": "Servido",
        "R": "Reservado",
        "F": "Tramitado",
        "T": "Pendiente Revision",
        "B": "Bloqueo-Pendiente",
        "O": "Pendiente"
    }

    mostrarCarga: boolean = false;

    /*
      * Inicialización parametros tabla consulta devoluciones
      * */

    devolucionesEncontradas:DevolucioElement[] = [];
    displayedColumnsDev: string[] = ['matricula', 'peticion', 'pet_aurgi','estado', "gestion_actual", "botonPdf"];
    dataSourceDev: MatTableDataSource<DevolucioElement> = new MatTableDataSource(this.devolucionesEncontradas);

    fechaInicioDev:Date = new Date();
    fechaFinDev:Date = new Date();
    matriculaDev : string = "";
    peticionDev : string = "";
    expandedElement: null | undefined;
    mostrarCargaDev: boolean = false;


    cargaSecundarios: boolean = true;
    /*
    * Parametro para paginar tabla.
    * */
    @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | undefined;
    @ViewChild(MatPaginator) paginatorDev: MatTableDataSourcePaginator | undefined;

    rowsPeticiones: number = 0;
    rowsDevoluciones: number = 0;


    /*
      * Parametros gestión tabs
      * */

    activeTab = 'tab_gestion';
    @ViewChild('tab_gestion') tabGestion!: ElementRef;
    @ViewChild('tab_consulta') tabConsulta!: ElementRef;
    @ViewChild('overlayContainer', { read: ViewContainerRef }) overlayContainer!: ViewContainerRef;


    constructor(private http: HttpClient,private viewContainerRef: ViewContainerRef,
                public dialog: MatDialog,private router: Router, private cdr: ChangeDetectorRef) {
        this.fechaInicio = new Date();
        this.fechaInicio.setDate(this.fechaInicio.getDate() - 7);

        this.fechaInicioDev = new Date();
        this.fechaInicioDev.setDate(this.fechaInicioDev.getDate() - 7);
    }
    ngOnDestroy(): void {
        const currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth() - 1);
        const newData = new Date();
        newData.setDate(newData.getDate() + 1);
        this.fechaFin = newData;
        this.fechaInicio = currentDate;
        this.fechaInicio.setDate(currentDate.getDate() - 7);
        this.fechaFinDev = newData;
        this.fechaInicioDev = currentDate;
        this.fechaInicioDev.setDate(currentDate.getDate() - 7);
    }

    ngOnInit(): void {

        this.token = FuncionesExterno.getToken()!;

        FuncionesExterno.getDataUser(this.token, this.http).then((response: any) => {

                PeticionesComponent.username = response.userPrincipalName.split("@")[0];
                this.buttonText = PeticionesComponent.username;
                this.buttonIcon = this.urlIconUser;
        });
    }

  // Método para obtener la imagen correspondiente al estado seleccionado
  getSelectedImage(): string {
    const estado = this.estados.find(e => e.value === this.selectedEstado);
    return estado ? estado.img : '../../assets/icons/speed/icon_estado_pet.svg';
  }

  toggleRow(element: any): void {
    if (this.expandedElement === element) {
      this.expandedElement = null; // Cierra el detalle si ya está expandido
    } else {
      this.expandedElement = element;
      this.cargaSecundarios = true;
      this.cargarDatoTablaExtended(element);
    }
  }

  /* Esta función realiza la busqueda del detalle de la petición y la carga en detailData.
   * Es importante que si se añaden columnas se añada en nombrePersonalizadoDetalle y displayedColumnsDetalle
   */
  cargarDatoTablaExtended(element: any){
    let arrParams =
      {
        matricula: "",
        parameters: {
          parameters:
            [
              [
                {
                  campo: PetTall.prefix + ".peticion_padre",
                  operacion:"=",
                  valor: element.peticion.toString()
                },
                {
                    campo: PetTall.prefix + ".peticio",
                    operacion:"=",
                    valor: element.peticion.toString()
                }
              ]
            ],
          select:[PetTall.prefix + ".peticio as peticion", PetTall.prefix + ".par_001 as estado", PetTall.prefix + ".par_004 as cdn", "TO_CHAR("+ PetTall.prefix + ".fec_prev_tall, 'DD-MM-YYYY') as f_entrega", PetTall.prefix + ".par_001 as gestion", PetTall.prefix + ".par_013 as gestion_final", PetTall.prefix + ".ref_prov as eurocode",PetTall.prefix + ".oem as oem", PetTall.prefix + ".articulo as ref_ral"]
        }
      };
    Peticiones.getDetallePet(this.http, arrParams).then(
      (res: any)=>
      {
        this.detailData = [];
        if (res.length > 0)
        {
          for (let i = 0; i < res.length; i++)
          {
            this.detailData[element.id] = res;
          }
          this.cargaSecundarios = false;
        }else{
          this.cargaSecundarios = false;
        }
      }
    ).catch(
      (err: any)=>
      {
        console.log(err);
      }
    );
  }
  ngAfterViewInit() {
      setTimeout(() => {
        this.openTab('tab_gestion'); //Establece la pestaña inicial
          if (this.paginator) {
            this.dataSource.paginator = this.paginator;
          }
          if (this.paginatorDev) {
            this.dataSourceDev.paginator = this.paginatorDev;
          }
        });

  }

    /*
     * Función que gestiona el cambio de pestaña y su contenido
     * */
    openTab(tabName: string) {
        //Actualizar el tab activo
        this.activeTab = tabName;
        // Ocultar todas las pestañas
        this.tabGestion.nativeElement.style.display = 'none';
        this.tabConsulta.nativeElement.style.display = 'none';
        // Mostrar la pestaña deseada
        if (tabName === 'tab_gestion') {
            this.tabGestion.nativeElement.style.display = 'block';
            this.buscarPeticion()
        } else if (tabName === 'tab_consulta') {
            this.tabConsulta.nativeElement.style.display = 'block';
            this.buscarDevolucion();
        }
    }

    // Al hacer hover sobre el botón
    onHover() {
        this.buttonText = 'Cerrar sesión';
        this.buttonIcon = this.urlIconClose;
    }

    // Al quitar el hover del botón
    onLeave() {
        this.buttonText = PeticionesComponent.username;
        this.buttonIcon = this.urlIconUser;
    }

    logout() {
      FuncionesExterno.logout();
      this.router.navigate(['/externo']);
    }

    onPageChange(event: any, paginator: MatPaginator)
    {
      if (this.mostrarCarga) {
        return;
      }

      this.refrescarDatasource(event.pageIndex, event.pageSize, paginator);
    }
    refrescarDatasource(pageIndex: number, pageSize: number, paginator: MatPaginator)
    {
        if (paginator == this.paginator){
          this.buscarPeticion(pageIndex, pageSize);
        }else{
            this.buscarDevolucion(pageIndex, pageSize)
        }
    }

    tallerCambiado(){
      if (this.tallerActual.trim() != ""){
        if (this.tabGestion.nativeElement.style.display == "block") {
          this.buscarPeticion();
        } else {
          this.buscarDevolucion();
        }
      }
    }

    // Traduce los estados nuevos de las peticiones
     traductorEstadosNuevosPet(par1: string, par4: string){
      if (par4 === '' && !['S', 'A'].includes(par1)){
        return "Chequeando";
      } else if (['1'].includes(par4) || (par1 === 'R' && par4 === 'a')){
        return "Procesando";
      } else if (par4 === '2' && par1 !== 'A'){
        return "Empaquetado";
      } else if (par4 === 'A'){
        return "Enviado";
      } else if (par1 === 'S'){
        return "Recepcionado";
      } else if (par1 === 'A'){
        return "Anulado";
      } else {
        return "";
      }
    }

    /* Funcion que revisa si se ha puesto información en el filtro para habilitar el limpiar */

    checkLimpiar(){
      if((this.fechaPrevInicio && this.fechaPrevFin) || this.peticionPet ||
        (this.selectedEstado && this.selectedEstado.trim()!="") || (this.selectedCat && this.selectedCat.trim() != "") ||
          this.matriculaPet || this.eurocode){
        return true;
      } else{
        return false;
      }
    }

    limpiarFiltros(){
        this.fechaPrevInicio = undefined;
        this.fechaPrevFin = undefined;
        this.peticionPet = "";
        this.selectedEstado = "";
        this.selectedCat = "";
        this.matriculaPet = "";
        this.eurocode = "";
    }
    buscarPeticion(pageIndex: number = 0, pageSize: number = 30){
        const offset = pageIndex * pageSize;

        let fIniParseada = new Date(this.fechaInicio.getFullYear(), this.fechaInicio.getMonth(), this.fechaInicio.getDate()).toLocaleDateString('en-CA');
        let fFinParseada = new Date(this.fechaFin.getFullYear(), this.fechaFin.getMonth(), this.fechaFin.getDate()).toLocaleDateString('en-CA');

        let fPrevIniParse = "";
        let fPrevFinParse = "";

        if(this.fechaPrevInicio && this.fechaPrevFin){
          fPrevIniParse = new Date(this.fechaPrevInicio.getFullYear(), this.fechaPrevInicio.getMonth(), this.fechaPrevInicio.getDate()).toLocaleDateString('en-CA');
          fPrevFinParse = new Date(this.fechaPrevFin.getFullYear(), this.fechaPrevFin.getMonth(), this.fechaPrevFin.getDate()).toLocaleDateString('en-CA');
        }

        //Fecha minimo 25/10/2024
        if (fIniParseada < "2024-10-25") fIniParseada = "2024-10-25";

        //creamos esto para especificar los otros filtros que pueden haber
        let arrParams=
            {
                matricula: "",
                estado:"",
                parameters:{
                    parameters:
                        [
                            [
                                {
                                    campo: PetTall.prefix + ".fecha",
                                    operacion:">=",
                                    valor:fIniParseada
                                }
                            ],
                            [
                                {
                                    campo: PetTall.prefix + ".fecha",
                                    operacion:"<=",
                                    valor:fFinParseada
                                }
                            ]
                        ],
                    select:[PetTall.prefix + ".peticio as peticion", PetTall.prefix + ".par_001 as estado",PetTall.prefix + ".par_004 as cdn", "TO_CHAR("+ PetTall.prefix + ".fec_prev_tall, 'DD-MM-YYYY') as estimacion_entrega", PetTall.prefix + ".par_001 as gestion", PetTall.prefix + ".par_013 as gestion_final"],
                    orden: [[PetTall.prefix + ".peticio", "desc"]],
                    limit: pageSize,
                    offset: offset
                }
            };

        //vamos agregando filtros si sus campos tienen valores validos
        if(fPrevIniParse && fPrevFinParse){
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".fec_prev_tall",
            operacion:">=",
            valor:fPrevIniParse
          }]);
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".fec_prev_tall",
            operacion:"<=",
            valor:fPrevFinParse
          }]);
        }

        if(this.peticionPet.trim()!=""){
            arrParams.parameters.parameters.push([{
                campo: PetTall.prefix + ".peticio",
                operacion:"LIKE",
                valor:this.peticionPet.trim()+"%"
            }]);
        }

        if(this.selectedEstado && this.selectedEstado.trim()!=""){
          this.crearFiltroEstadoPet(arrParams);
        }

        if(this.tallerActual.trim() != ""){
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".empresa",
            operacion:"=",
            valor: this.tallerActual
          }]);
        }

        if(this.selectedCat && this.selectedCat.trim() != ""){
          arrParams["estado"] = this.selectedCat.trim().toUpperCase();
        }

        if(this.matriculaPet.trim()!=""){
          arrParams["matricula"] = this.matriculaPet.trim().toUpperCase();
        }

        if(this.eurocode.trim()!=""){
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".ref_prov",
            operacion:"LIKE",
            valor: this.eurocode.trim()+"%"
          }]);
        }

        this.mostrarCarga = true;

        Peticiones.getPeticiones(this.http, arrParams).then((res) => {

            this.peticionesEncontradas = res.data;
            this.dataSource.data = this.peticionesEncontradas;

            this.rowsPeticiones = res.count;
            setTimeout(() => {
              if (this.paginator) {
                this.paginator.length = this.rowsPeticiones; // Longitud total
                this.paginator.pageIndex = pageIndex; // Mantén el índice actual
              }
            });

            this.mostrarCarga = false;
        });
    }

    crearFiltroEstadoPet(arrParams: any){
      switch (this.selectedEstado.trim()){
        case "O":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_001",
            operacion:"NOT IN",
            valor2: ['S', 'A']
          }]);
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_004",
            operacion:"NOT IN",
            valor2:  ['1', 'm', '2', 'B', 'x', 'A', 'a']
          }]);
          break;
        case "1":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_004",
            operacion:"IN",
            valor2: ['1', 'm']
          }]);
          break;
        case "2":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_004",
            operacion:"=",
            valor: "2"
          }]);
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_001",
            operacion:"!=",
            valor: "A"
          }])
          break;
        case "A":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_004",
            operacion:"=",
            valor: "A"
          }]);
          break;
        case "S":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_001",
            operacion:"=",
            valor: "S"
          }]);
          break;
        case "An":
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".par_001",
            operacion:"=",
            valor: "A"
          }]);
          break;
      }
    }
    gestionarPeticion(row: any, estado:string){
        var peticion:PetTall = new PetTall();

        switch (estado){
            case 'cancel-btn':
                AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["¿Esta seguro de querer cancelar?"], true, false, false, this.dialog, true).subscribe(result => {
                  if (result){
                    peticion.peticio = row.peticion;
                    peticion.empresa = 0;
                    peticion.periode = 0;
                    peticion.par_001 = "A";
                    peticion.par_009 = "M";
                    peticion.par_013 = "C";

                    var gestion= {
                      "peticion": row.peticion,
                      "gestion": "C",
                      "finalizada": false
                    }
                    Gestiones.createGestion(this.http, gestion).then((res) => {
                      console.log("Gestión realizada con éxito")
                    });

                    peticion.updatePeticionExterno(this.http).then((res) => {
                      AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["Gestión realizada con éxito"], true, true, false, this.dialog).subscribe(result => {this.buscarPeticion();});
                      this.buscarPeticion();
                    });
                  }
                });
                break;
            case 'receive-btn':
                AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["¿Esta seguro de querer recepcionar?"], true, false, false, this.dialog, true).subscribe(result => {
                  if (result){
                    peticion.peticio = row.peticion;
                    peticion.empresa = 0;
                    peticion.periode = 0;
                    peticion.par_013 = "R";
                    peticion.par_001 = "S";

                    var gestion= {
                      "peticion": row.peticion,
                      "gestion": "R",
                      "finalizada": true
                    }

                    Gestiones.createGestion(this.http, gestion).then((res) => {
                      console.log("Gestión realizada con éxito")
                    });

                    peticion.updatePeticionExterno(this.http).then((res) => {
                      AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["Gestión realizada con éxito"], true, true, false, this.dialog).subscribe(result => {this.buscarPeticion();});
                      this.buscarPeticion();
                    });
                  }
                });
                break;
            case 'reclaim-btn':
                peticion.peticio = row.peticion;
                peticion.empresa = 0;
                peticion.periode = 0;
                peticion.par_013 = "E";

                this.mostrarReclamacion(peticion, "reclamacion");
                break;
            case 'return-btn':
                peticion.peticio = row.peticion;
                peticion.empresa = 0;
                peticion.periode = 0;
                peticion.par_013 = "D";

                this.mostrarReclamacion(peticion, "devolucion");
                break;
        }
    }

    mostrarReclamacion(petTall: PetTall, tipo:string){
        this.dialog.open(ReclamacionesOverlay, { data: { petTall: petTall, tipo: tipo }, width:"700px", disableClose: true}).afterClosed().subscribe(res=>{
            if (res == null) return;

            petTall.updatePeticionExterno(this.http).then(() => {
                this.buscarPeticion();
                AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["Gestión realizada con éxito"], true, true, false, this.dialog).subscribe(result => {this.buscarPeticion();});
          });
        });

    }

    condicionBotonPeticion(element: any){
      const { gestion, cdn, gestion_final } = element;
      const gestionFinalVaciaOR = gestion_final?.trim() === '' || gestion_final?.trim() === 'R';

      return (!["", "R", "T", "O"].includes(gestion.trim()) || cdn.trim() === "") && gestionFinalVaciaOR;
    }

    buscarDevolucion(pageIndex: number = 0, pageSize: number = 30){
        const offset = pageIndex * pageSize;

        let fIniParseada = new Date(this.fechaInicioDev.getFullYear(), this.fechaInicioDev.getMonth(), this.fechaInicioDev.getDate()).toLocaleDateString('en-CA');
        let fFinParseada = new Date(this.fechaFinDev.getFullYear(), this.fechaFinDev.getMonth(), this.fechaFinDev.getDate()).toLocaleDateString('en-CA');

      //creamos esto para especificar los otros filtros que pueden haber
        let arrParams =
            {
                matricula: "",
                parameters: {
                    parameters:
                        [
                            [
                                {
                                    campo: PetTall.prefix + ".fecha",
                                    operacion:">=",
                                    valor:fIniParseada
                                }
                            ],
                            [
                                {
                                    campo: PetTall.prefix + ".fecha",
                                    operacion:"<=",
                                    valor:fFinParseada
                                }
                            ],
                            [
                                {
                                    campo: PetTall.prefix + ".par_001",
                                    operacion:"IN",
                                    valor2:["F", "E", "T", "B", "O", "S"]
                                }
                            ],
                            [
                                {
                                    campo: PetTall.prefix + ".par_013",
                                    operacion:"=",
                                    valor: "D"
                                }
                            ]
                        ],
                    select:[PetTall.prefix + ".peticio as peticion", PetTall.prefix + ".par_001 as estado", PetTall.prefix + ".par_013 as gestion_actual"],
                    orden: [[PetTall.prefix + ".peticio", "desc"],[PetTall.prefix + ".fecha", "desc"]],
                    limit: pageSize,
                    offset: offset
                }
            };

        //vamos agregando filtros si sus campos tienen valores validos
        if(this.matriculaDev.trim()!=""){
            arrParams ["matricula"] = this.matriculaPet.trim().toUpperCase()
        }

        if(this.peticionDev.trim()!=""){
            arrParams.parameters.parameters.push([{
                campo: PetTall.prefix + ".peticio",
                operacion:"LIKE",
                valor:this.peticionDev.trim()+"%"
            }]);
        }

        if(this.tallerActual.trim() != ""){
          arrParams.parameters.parameters.push([{
            campo: PetTall.prefix + ".empresa",
            operacion:"=",
            valor: this.tallerActual
          }]);
        }

        this.mostrarCarga = true;

        Peticiones.getPeticiones(this.http, arrParams).then((res) => {
            this.devolucionesEncontradas = res.data;
            this.dataSourceDev.data = this.devolucionesEncontradas;

            this.rowsDevoluciones = res.count;
            setTimeout(() => {
              if (this.paginatorDev) {
                this.paginatorDev.length = this.rowsDevoluciones; // Longitud total
                this.paginatorDev.pageIndex = pageIndex; // Mantén el índice actual
              }
            });

            this.mostrarCargaDev = false;
        });
    }

    loadOverlay(peticion:PeticioElement) {
        this.dialog.open(DetallePeticionComponent, {data: {peticion: peticion["peticion"]}, width:"750px"});
    }

    loadOverlayDevolucion(peticion:PeticioElement) {
        this.dialog.open(DetalleDevolucionComponent, {data: {peticion: peticion["peticion"]}, width:"750px", height:"300px"});
    }

    checkSuperUser(){
      if (this.usuariosSupervisor.includes(PeticionesComponent.username)){
        return true;
      }

      return false;
    }

    descargarPDFAlbaran(devolucion:any){
        Gestiones.getPdfAlbaran(this.http, devolucion.peticion, this.dialog);
    }


    protected readonly Peticiones = Peticiones;
}
